import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout } from "./authSlice";

// Backend base URL. CRA sets NODE_ENV to "production" in `npm run build`, so
// production bundles hit the deployed backend while local dev uses .env / localhost.
const API_URI =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PROD_URL
    : process.env.REACT_APP_BASE_URL || "http://localhost:8800";

// `credentials: "include"` makes the browser send/receive the httpOnly auth
// cookie. The token is no longer read from JS state — it lives only in the
// cookie, so there's no Authorization header to set here.
const baseQuery = fetchBaseQuery({
  baseUrl: `${API_URI}/api`,
  credentials: "include",
});

// On a 401 from any endpoint, the cookie is missing/expired — clear the
// client-side user so the UI reflects logged-out state (re-login via modal).
const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    api.dispatch(logout());
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Favourites", "Notes"],
  endpoints: () => ({}),
});
